// ==================================================================
// Paw Name Generator — core logic
// ==================================================================

// Library loader
function loadScript(urls){
  return new Promise((res,rej)=>{
    let i=0;
    (function next(){
      if(i>=urls.length){rej(new Error('All CDNs failed'));return;}
      const s=document.createElement('script');
      s.src=urls[i++];
      s.onload=res;
      s.onerror=()=>{s.remove();next();};
      document.head.appendChild(s);
    })();
  });
}
const LIB={
  opentype:[
    'https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js',
    'https://unpkg.com/opentype.js@1.3.4/dist/opentype.min.js',
  ],
  clipper:[
    'https://cdn.jsdelivr.net/npm/clipper-lib/clipper.js',
    'https://cdn.jsdelivr.net/npm/clipper-lib@6.4.2/clipper.js',
    'https://unpkg.com/clipper-lib/clipper.js',
    'https://unpkg.com/clipper-lib@6.4.2/clipper.js',
    'https://cdnjs.cloudflare.com/ajax/libs/clipper-lib/6.4.2/clipper.js',
  ],
};

// Constants
const W=600,H=520,PAW_W=351.903,PAW_H=331.702;
const FLATTEN_TOL=0.35;
const RDP_EPS=0.6;
const CS=100; // Clipper scale (coords -> integers)
const GAP=20;
const INTERNAL_SEAM_EPS=1.2;
const MIN_SEAM_LEN=8;
const BEIGE='#C9A882',BROWN='#5C3317',BACK_FILL='#8B5534',BG='#f0ece4';
const PSW=1.4;
const BACK_OFFSET=7;

const PAW='M342.591,120.028c-7.691-15.636-19.159-25.118-32.278-26.672c-1.351-0.164-2.76-0.25-4.15-0.25c-6.163,0-12.137,1.635-17.893,4.878c0.134-0.947,0.258-1.896,0.361-2.851c1.7-15.608-1.834-32.157-10.221-47.847c-7.308-13.672-18.272-26.442-30.873-35.959c-9.54-7.205-20.376-11.173-30.512-11.173c-12.61,0-23.286,6.089-30.063,17.144c-6.367,10.387-9.398,22.549-10.943,35.095c-1.822-14.585-6.143-32.613-18.723-43.921C151.111,2.926,143.476,0,135.206,0c-18.542,0-35.418,14.657-41.814,20.959C81.82,32.362,62.494,56.045,63.08,86.534c0.075,3.965,0.47,8.027,1.145,12.091c-6.03-3.455-12.396-5.28-18.721-5.28c-8.888,0-17.276,3.596-24.257,10.398C7.694,116.947-0.05,137.069,0,158.949c0.052,22.733,8.223,43.629,22.416,57.331c10.368,10.009,23.361,16.062,36.09,16.93c-4.988,8.677-8.072,18.434-8.964,28.503c-1.113,12.567,1.307,24.656,7.001,34.961c7.111,12.889,19.77,23.254,35.639,29.178c9.76,3.68,19.749,5.477,30.497,5.477c13.19,0,25.916-2.822,35.53-5.281c7.4-1.893,13.085-2.737,18.435-2.737c2.877,0,5.602,0.25,8.331,0.763c3.887,0.725,7.816,1.785,11.975,2.907c3.104,0.837,6.314,1.703,9.626,2.457c6.667,1.505,13.619,2.265,20.688,2.265c31.664,0,58.374-14.765,69.706-38.532c8.469-17.762,7.069-39.424-3.763-59.822c15.489-0.949,30.049-8.955,41.245-22.775c10.225-12.621,16.539-28.734,17.325-44.206C352.603,150.125,349.34,133.668,342.591,120.028zM187.555,72.359c0.608-15.599,2.126-34.621,10.492-48.267c4.815-7.856,11.702-10.938,18.979-10.938c7.802,0,16.052,3.544,22.677,8.547c21.614,16.323,39.031,44.233,36.003,72.034c-0.743,6.873-2.464,13.788-5.179,20.264c-2.604,6.211-6.122,12.019-10.592,16.989c-0.826,0.92-1.681,1.776-2.553,2.592c-7.364,6.896-16.272,10.136-25.164,10.136c-13.915,0-27.78-7.911-35.572-22.06C188.492,106.852,186.906,88.956,187.555,72.359zM102.517,30.219C110.366,22.485,123.239,13,135.206,13c4.73,0,9.32,1.483,13.4,5.141c12.468,11.206,14.608,33.554,15.686,48.737c2.042,28.759-4.075,69.207-37.699,76.545c-2.686,0.587-5.271,0.865-7.755,0.865c-9.162,0-16.927-3.788-23.23-9.729c-5.342-5.035-9.63-11.617-12.811-18.779c-4.26-9.593-6.543-20.209-6.719-29.495C75.667,64.899,87.663,44.856,102.517,30.219zM31.445,206.927c-23.617-22.799-25.157-70.46-1.126-93.873c4.852-4.728,10.048-6.709,15.185-6.709c8.063,0,15.976,4.886,22.156,11.704c1.357,1.498,2.7,3.054,4.023,4.653c5.006,6.051,9.706,12.789,13.602,19.952c7.206,13.249,11.665,27.94,10.237,42.376c-0.333,3.364-1.04,6.727-2.103,9.97c-3.618,11.037-11.399,20.669-22.945,24.08c-0.662,0.194-1.326,0.358-1.992,0.505c-2.267,0.503-4.551,0.745-6.828,0.745C50.449,220.33,39.415,214.621,31.445,206.927zM285.236,287.575c-10.268,21.536-34.706,31.127-57.971,31.127c-6.106,0-12.134-0.661-17.8-1.94c-7.396-1.685-14.622-4.072-22.086-5.465c-3.636-0.684-7.201-0.987-10.735-0.987c-7.231,0-14.333,1.269-21.656,3.143c-11.105,2.84-21.715,4.876-32.308,4.876c-8.576,0-17.142-1.334-25.951-4.656c-11.772-4.395-22.647-12.121-28.807-23.286c-9.279-16.794-6.525-38.576,3.969-54.097c1.236-1.828,2.556-3.578,3.936-5.274c8.662-10.646,19.804-19.032,29.006-29.213c0.568-0.628,1.134-1.258,1.686-1.901c9.959-11.6,17.291-25.391,28.39-36.02c11.117-10.646,25.972-15.919,40.966-15.919c7.897,0,15.835,1.464,23.282,4.376c7.151,2.795,13.871,6.865,19.516,12.084c11.83,10.906,15.408,27.414,26.498,38.943c1.839,1.912,3.76,3.673,5.718,5.359c8.786,7.567,18.385,13.438,25.609,22.612c1.456,1.849,2.826,3.819,4.061,5.98C289.175,252.386,292.975,271.343,285.236,287.575zM338.794,165.708c-1.271,25.038-21.108,54.532-48.407,54.744c-0.095,0.001-0.187,0.001-0.281,0.001c-2.224,0-4.329-0.231-6.331-0.641c-10.612-2.178-18.098-9.792-22.524-19.355c-4.378-9.46-5.769-20.813-4.212-30.687c1.574-9.894,5.613-19.252,10.631-28.049c3.18-5.574,6.75-10.924,10.345-16.037c1.164-1.655,2.424-3.343,3.776-4.999c6.221-7.625,14.406-14.579,24.371-14.579c0.86,0,1.735,0.052,2.621,0.16c10.508,1.244,17.802,10.678,22.155,19.527C336.962,137.966,339.481,152.19,338.794,165.708z';

// State
const DEF={name:'Pablo',fontSize:160,letterSpacing:-22,nameOffsetY:85,hoopEnabled:false,exportHeightMm:101.6,exportUnit:'in'};
const S={...DEF};
let font=null,data=null,timer=null,ready=false;

// Paw geometry cache — computed once, reused on every keystroke
let pawCache=null;

const EXPORT_MIN_MM=40,EXPORT_MAX_MM=520;

// ==================================================================
// Unit & export helpers
// ==================================================================

function mmToUnit(mm,unit){return unit==='in'?mm/25.4:mm;}
function unitToMm(value,unit){return unit==='in'?value*25.4:value;}
function fmtMeasure(value,unit){
  const digits=unit==='in'?2:1;
  return parseFloat(value.toFixed(digits)).toString();
}
function currentBackBounds(){return data&&data.backCutBounds?data.backCutBounds:{x:0,y:0,w:W,h:H};}
function exportScaleInUnit(unit){
  const bounds=currentBackBounds();
  return mmToUnit(S.exportHeightMm,unit)/Math.max(bounds.h,1e-6);
}
function baseLayerWidthInUnit(unit){
  const bounds=currentBackBounds();
  return bounds.w*exportScaleInUnit(unit);
}
function fmtExportDims(){
  const unit=S.exportUnit;
  const w=baseLayerWidthInUnit(unit),h=mmToUnit(S.exportHeightMm,unit);
  return `Final size: ${fmtMeasure(w,unit)} x ${fmtMeasure(h,unit)} ${unit}`;
}
function syncExportUi(){
  const input=document.getElementById('ehInput');
  if(input){
    input.step=S.exportUnit==='in'?'0.01':'0.1';
    input.min=fmtMeasure(mmToUnit(EXPORT_MIN_MM,S.exportUnit),S.exportUnit);
    input.max=fmtMeasure(mmToUnit(EXPORT_MAX_MM,S.exportUnit),S.exportUnit);
    input.value=fmtMeasure(mmToUnit(S.exportHeightMm,S.exportUnit),S.exportUnit);
  }
  const dims=document.getElementById('exportDims');
  if(dims)dims.textContent=fmtExportDims();
  document.querySelectorAll('#unitSeg .sb').forEach(b=>b.classList.toggle('on',b.dataset.unit===S.exportUnit));
}

// ==================================================================
// Paw transform / hoop
// ==================================================================

function pawTf(){
  const sc=Math.min((H*.74)/PAW_H,(W*.74)/PAW_W);
  return{sc,tx:(W-PAW_W*sc)/2,ty:(H-PAW_H*sc)/2-8};
}
function gTf(t){return `translate(${t.tx.toFixed(2)},${t.ty.toFixed(2)}) scale(${t.sc.toFixed(5)})`;}

const HR=20,hIR=11;
function hoopPos(){const{ty}=pawTf();return{cx:W/2,cy:ty+HR*.4};}
function circlePath(cx,cy,r){const x0=(cx-r).toFixed(2),x1=(cx+r).toFixed(2),c=cy.toFixed(2);return `M${x0},${c} A${r},${r} 0 1 0 ${x1},${c} A${r},${r} 0 1 0 ${x0},${c} Z`;}
function ringPath(h){return `${circlePath(h.cx,h.cy,HR)} ${circlePath(h.cx,h.cy,hIR)}`;}
function circleContour(cx,cy,r,steps=96){
  const pts=[];
  for(let i=0;i<steps;i++){
    const a=(i/steps)*Math.PI*2;
    pts.push([cx+Math.cos(a)*r,cy+Math.sin(a)*r]);
  }
  return pts;
}

// ==================================================================
// SVG path parser
// ==================================================================

function parsePath(d){
  const segs=d.match(/[MmLlCcQqZzHhVvSsAa][^MmLlCcQqZzHhVvSsAa]*/g)||[];
  const nr=/-?(?:\d+\.?\d*|\.\d+)(?:[eE][+-]?\d+)?/g;
  const c=[];let cx=0,cy=0,sx=0,sy=0;
  for(const seg of segs){const t=seg[0],n=(seg.slice(1).match(nr)||[]).map(Number);
    if(t==='M'){for(let i=0;i<n.length;i+=2){c.push({type:i?'L':'M',x:n[i],y:n[i+1]});cx=n[i];cy=n[i+1];if(!i){sx=cx;sy=cy;}}}
    else if(t==='m'){for(let i=0;i<n.length;i+=2){cx+=n[i];cy+=n[i+1];c.push({type:i?'L':'M',x:cx,y:cy});if(!i){sx=cx;sy=cy;}}}
    else if(t==='L'){for(let i=0;i<n.length;i+=2){c.push({type:'L',x:n[i],y:n[i+1]});cx=n[i];cy=n[i+1];}}
    else if(t==='l'){for(let i=0;i<n.length;i+=2){cx+=n[i];cy+=n[i+1];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='H'){for(let i=0;i<n.length;i++){cx=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='h'){for(let i=0;i<n.length;i++){cx+=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='V'){for(let i=0;i<n.length;i++){cy=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='v'){for(let i=0;i<n.length;i++){cy+=n[i];c.push({type:'L',x:cx,y:cy});}}
    else if(t==='C'){for(let i=0;i<n.length;i+=6){c.push({type:'C',x1:n[i],y1:n[i+1],x2:n[i+2],y2:n[i+3],x:n[i+4],y:n[i+5]});cx=n[i+4];cy=n[i+5];}}
    else if(t==='c'){for(let i=0;i<n.length;i+=6){c.push({type:'C',x1:cx+n[i],y1:cy+n[i+1],x2:cx+n[i+2],y2:cy+n[i+3],x:cx+n[i+4],y:cy+n[i+5]});cx+=n[i+4];cy+=n[i+5];}}
    else if(t==='Q'){for(let i=0;i<n.length;i+=4){c.push({type:'Q',x1:n[i],y1:n[i+1],x:n[i+2],y:n[i+3]});cx=n[i+2];cy=n[i+3];}}
    else if(t==='q'){for(let i=0;i<n.length;i+=4){c.push({type:'Q',x1:cx+n[i],y1:cy+n[i+1],x:cx+n[i+2],y:cy+n[i+3]});cx+=n[i+2];cy+=n[i+3];}}
    else if(t==='Z'||t==='z'){c.push({type:'Z'});cx=sx;cy=sy;}}
  return c;
}
function xfCmds(c,sc,tx,ty){return c.map(p=>{if(p.type==='M'||p.type==='L')return{type:p.type,x:p.x*sc+tx,y:p.y*sc+ty};if(p.type==='C')return{type:'C',x1:p.x1*sc+tx,y1:p.y1*sc+ty,x2:p.x2*sc+tx,y2:p.y2*sc+ty,x:p.x*sc+tx,y:p.y*sc+ty};if(p.type==='Q')return{type:'Q',x1:p.x1*sc+tx,y1:p.y1*sc+ty,x:p.x*sc+tx,y:p.y*sc+ty};return p;});}

// ==================================================================
// Font loading
// ==================================================================

async function loadFont(){
  if(!ready)return;
  showOv('Loading Chewy...');
  data=null;
  document.getElementById('dlBtn').disabled=true;
  const u=[
    'https://cdn.jsdelivr.net/npm/@fontsource/chewy/files/chewy-latin-400-normal.woff',
    'https://cdn.jsdelivr.net/npm/@fontsource/chewy@5/files/chewy-latin-400-normal.woff',
    'https://cdn.jsdelivr.net/npm/@fontsource/chewy@4/files/chewy-latin-400-normal.woff',
  ];
  for(const url of u){
    try{
      const r=await fetch(url);
      if(!r.ok)throw 0;
      font=opentype.parse(await r.arrayBuffer());
      hideOv();
      sched();
      return;
    }catch(e){}
  }
  showOv('Font load failed - reload.',0,true);
}

// ==================================================================
// Bezier flatten & RDP simplification
// ==================================================================

function mp(a,b){return[(a[0]+b[0])*.5,(a[1]+b[1])*.5];}
function fc(p0,p1,p2,p3,tq,o){
  const ux=3*p1[0]-2*p0[0]-p3[0],uy=3*p1[1]-2*p0[1]-p3[1],vx=3*p2[0]-2*p3[0]-p0[0],vy=3*p2[1]-2*p3[1]-p0[1];
  if(Math.max(ux*ux+uy*uy,vx*vx+vy*vy)<=16*tq){o.push(p3);return;}
  const q0=mp(p0,p1),q1=mp(p1,p2),q2=mp(p2,p3),r0=mp(q0,q1),r1=mp(q1,q2),s=mp(r0,r1);
  fc(p0,q0,r0,s,tq,o);fc(s,r1,q2,p3,tq,o);
}
function flatten(cmds,tol){
  const tq=tol*tol,cs=[];let pts=[],lx=0,ly=0;
  for(const c of cmds){
    if(c.type==='M'){if(pts.length>=3)cs.push(pts);pts=[[c.x,c.y]];lx=c.x;ly=c.y;}
    else if(c.type==='L'){pts.push([c.x,c.y]);lx=c.x;ly=c.y;}
    else if(c.type==='C'){const f=[];fc([lx,ly],[c.x1,c.y1],[c.x2,c.y2],[c.x,c.y],tq,f);pts.push(...f);lx=c.x;ly=c.y;}
    else if(c.type==='Q'){const x1=lx+(2/3)*(c.x1-lx),y1=ly+(2/3)*(c.y1-ly),x2=c.x+(2/3)*(c.x1-c.x),y2=c.y+(2/3)*(c.y1-c.y),f=[];fc([lx,ly],[x1,y1],[x2,y2],[c.x,c.y],tq,f);pts.push(...f);lx=c.x;ly=c.y;}
    else if(c.type==='Z'){if(pts.length>=3)cs.push(pts);pts=[];}
  }
  if(pts.length>=3)cs.push(pts);return cs;
}

function rdp(pts,e){
  if(pts.length<=2)return pts.slice();
  const a=pts[0],b=pts[pts.length-1],dx=b[0]-a[0],dy=b[1]-a[1],l=Math.sqrt(dx*dx+dy*dy)||1;
  let md=0,mi=1;
  for(let i=1;i<pts.length-1;i++){const d=Math.abs(dy*pts[i][0]-dx*pts[i][1]+b[0]*a[1]-b[1]*a[0])/l;if(d>md){md=d;mi=i;}}
  if(md>e){const L=rdp(pts.slice(0,mi+1),e),R=rdp(pts.slice(mi),e);return[...L.slice(0,-1),...R];}
  return[a,b];
}

// ==================================================================
// Smoothing to SVG C-commands
// ==================================================================

function closedSmooth(pts){
  if(!pts||pts.length<3)return'';
  const inp=[...pts,pts[0]];
  let s=rdp(inp,RDP_EPS);s.pop();
  if(s.length<3)s=pts;
  const n=s.length;
  let d=`M${s[0][0].toFixed(2)},${s[0][1].toFixed(2)}`;
  for(let i=0;i<n;i++){
    const p0=s[(i-1+n)%n],p1=s[i],p2=s[(i+1)%n],p3=s[(i+2)%n];
    d+=` C${(p1[0]+(p2[0]-p0[0])/6).toFixed(2)},${(p1[1]+(p2[1]-p0[1])/6).toFixed(2)}`
      +` ${(p2[0]-(p3[0]-p1[0])/6).toFixed(2)},${(p2[1]-(p3[1]-p1[1])/6).toFixed(2)}`
      +` ${p2[0].toFixed(2)},${p2[1].toFixed(2)}`;
  }
  return d+' Z';
}

function openSmooth(pts){
  if(!pts||pts.length<2)return'';
  let s=rdp(pts,RDP_EPS);
  if(s.length<2)s=pts;
  if(s.length===2)return`M${s[0][0].toFixed(2)},${s[0][1].toFixed(2)} L${s[1][0].toFixed(2)},${s[1][1].toFixed(2)}`;
  const n=s.length;
  let d=`M${s[0][0].toFixed(2)},${s[0][1].toFixed(2)}`;
  for(let i=0;i<n-1;i++){
    const p0=i===0?s[0]:s[i-1], p1=s[i], p2=s[i+1], p3=i+2<n?s[i+2]:s[n-1];
    d+=` C${(p1[0]+(p2[0]-p0[0])/6).toFixed(2)},${(p1[1]+(p2[1]-p0[1])/6).toFixed(2)}`
      +` ${(p2[0]-(p3[0]-p1[0])/6).toFixed(2)},${(p2[1]-(p3[1]-p1[1])/6).toFixed(2)}`
      +` ${p2[0].toFixed(2)},${p2[1].toFixed(2)}`;
  }
  return d;
}

function rawFillPath(contours){
  return contours.map(c=>{
    if(c.length<2)return'';
    let d=`M${c[0][0].toFixed(2)},${c[0][1].toFixed(2)}`;
    for(let i=1;i<c.length;i++)d+=` L${c[i][0].toFixed(2)},${c[i][1].toFixed(2)}`;
    return d+' Z';
  }).filter(Boolean).join(' ');
}
function clipperBounds(paths){
  let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
  for(const path of paths||[]){
    for(const pt of path){
      const x=pt.X/CS,y=pt.Y/CS;
      if(x<minX)minX=x;
      if(y<minY)minY=y;
      if(x>maxX)maxX=x;
      if(y>maxY)maxY=y;
    }
  }
  if(!isFinite(minX))return{x:0,y:0,w:W,h:H};
  return{x:minX,y:minY,w:maxX-minX,h:maxY-minY};
}

// ==================================================================
// CLIPPER HELPERS
// ==================================================================

function toCP(pts){return pts.map(p=>({X:Math.round(p[0]*CS),Y:Math.round(p[1]*CS)}));}
function fromCP(path){return path.map(p=>[p.X/CS,p.Y/CS]);}
function signedArea(pts){let a=0;for(let i=0;i<pts.length;i++){const j=(i+1)%pts.length;a+=pts[i][0]*pts[j][1]-pts[j][0]*pts[i][1];}return a/2;}
function ensureWinding(pts,clockwise){const isClockwise=signedArea(pts)<0;return isClockwise===clockwise?pts:pts.slice().reverse();}
function contourInside(contour,container){for(const pt of contour){const r=ClipperLib.Clipper.PointInPolygon({X:Math.round(pt[0]*CS),Y:Math.round(pt[1]*CS)},toCP(container));if(r!==0)return r!==-1;}return false;}
function normalizeCompoundContours(contours){
  return contours.filter(c=>c.length>=3).map((contour,index,all)=>{
    let depth=0;
    for(let i=0;i<all.length;i++){
      if(i===index)continue;
      if(contourInside(contour,all[i]))depth++;
    }
    const isHole=depth%2===1;
    return ensureWinding(contour,!isHole);
  });
}

function clipperUnion(contourSets){
  const subject=[];
  for(const contours of contourSets){
    const normalized=normalizeCompoundContours(contours);
    for(const c of normalized){
      subject.push(toCP(c));
    }
  }
  if(subject.length===0)return[];

  const clipper=new ClipperLib.Clipper();
  const simplified=ClipperLib.Clipper.SimplifyPolygons(subject,ClipperLib.PolyFillType.pftNonZero);
  clipper.AddPaths(simplified,ClipperLib.PolyType.ptSubject,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);

  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}

function buildArea(letterContourArrays){
  return clipperUnion(letterContourArrays);
}
function diffAreas(subjectArea,clipArea){
  if(!subjectArea||subjectArea.length===0)return[];
  if(!clipArea||clipArea.length===0)return subjectArea.slice();
  const clipper=new ClipperLib.Clipper();
  clipper.AddPaths(subjectArea,ClipperLib.PolyType.ptSubject,true);
  clipper.AddPaths(clipArea,ClipperLib.PolyType.ptClip,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctDifference,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}
function offsetAreas(paths,delta){
  if(!paths||paths.length===0||!delta)return paths?paths.slice():[];
  const co=new ClipperLib.ClipperOffset(2,0.25*CS);
  co.AddPaths(paths,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
  const sol=new ClipperLib.Paths();
  co.Execute(sol,delta*CS);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}
function unionAreas(paths){
  if(!paths||paths.length===0)return[];
  const clipper=new ClipperLib.Clipper();
  clipper.AddPaths(paths,ClipperLib.PolyType.ptSubject,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}

function polylineLength(pts){
  let len=0;
  for(let i=1;i<pts.length;i++)len+=Math.hypot(pts[i][0]-pts[i-1][0],pts[i][1]-pts[i-1][1]);
  return len;
}

// ==================================================================
// Point-in-area tests + visible-seam extraction
// ==================================================================

function ptInArea(pt,solPaths){
  if(!solPaths||solPaths.length===0)return false;
  const cp={X:Math.round(pt[0]*CS),Y:Math.round(pt[1]*CS)};
  let winding=0;
  for(const path of solPaths){
    const r=ClipperLib.Clipper.PointInPolygon(cp,path);
    if(r===-1)return true; // on boundary
    if(r!==0){
      const sign=Math.sign(ClipperLib.Clipper.Area(path))||1;
      winding+=sign;
    }
  }
  return winding!==0;
}

function findCrossing(pIn,pOut,area){
  let a=0,b=1;
  for(let i=0;i<12;i++){
    const t=(a+b)/2;
    const pm=[pIn[0]+(pOut[0]-pIn[0])*t,pIn[1]+(pOut[1]-pIn[1])*t];
    if(ptInArea(pm,area))a=t; else b=t;
  }
  const t=(a+b)/2;
  return[pIn[0]+(pOut[0]-pIn[0])*t,pIn[1]+(pOut[1]-pIn[1])*t];
}

function clipContourOutsideArea(contour,area){
  const n=contour.length;
  if(n<3)return[];
  const results=[];
  let run=[];
  const outside=contour.map(p=>!ptInArea(p,area));
  for(let i=0;i<n;i++){
    const j=(i+1)%n;
    if(outside[i])run.push(contour[i]);
    if(outside[i]&&!outside[j]){
      run.push(findCrossing(contour[j],contour[i],area));
      if(run.length>=2)results.push(run);
      run=[];
    }else if(!outside[i]&&outside[j]){
      run.push(findCrossing(contour[i],contour[j],area));
    }
  }
  if(run.length>=2)results.push(run);
  if(results.length>=2&&outside[0]){
    const first=results[0],last=results[results.length-1];
    results[0]=dedupeRunPoints([...last,...first.slice(1)]);
    results.pop();
  }
  return results;
}

function appendVisibleLetterSeams(contours,occluderArea,seamPathDs){
  for(const contour of contours){
    if(!contour||contour.length<3)continue;
    if(!occluderArea||occluderArea.length===0){
      seamPathDs.push(closedSmooth(contour));
      continue;
    }
    const fullyVisible=contour.every(pt=>!ptInArea(pt,occluderArea));
    if(fullyVisible){
      seamPathDs.push(closedSmooth(contour));
      continue;
    }
    for(const seg of clipContourOutsideArea(contour,occluderArea)){
      const clean=dedupeRunPoints(seg);
      if(clean.length>=2&&polylineLength(clean)>=1){
        seamPathDs.push(openSmooth(clean));
      }
    }
  }
}

function dedupeRunPoints(pts){
  if(pts.length<2)return pts.slice();
  const out=[pts[0]];
  for(let i=1;i<pts.length;i++){
    const a=out[out.length-1],b=pts[i];
    if(Math.hypot(a[0]-b[0],a[1]-b[1])>0.01)out.push(b);
  }
  return out;
}

// ==================================================================
// Paw geometry cache — built once, reused forever
// ==================================================================

function buildPawCache(){
  const tf=pawTf();
  const pawCmds=parsePath(PAW);
  const xfPaw=xfCmds(pawCmds,tf.sc,tf.tx,tf.ty);
  const pawContours=flatten(xfPaw,FLATTEN_TOL);
  const pawContoursCP=pawContours.map(c=>toCP(c)); // pre-serialized to Clipper ints
  return{tf,pawContours,pawContoursCP};
}

// Variant of clipperUnion that accepts one paw set (already in CP form) + raw letter contours
// This saves re-walking the paw contours through normalizeCompoundContours + toCP on every keystroke.
function clipperUnionWithCachedPaw(pawContoursCP,letterContourArrays){
  const subject=[...pawContoursCP.map(cp=>cp.slice())];
  for(const contours of letterContourArrays){
    const normalized=normalizeCompoundContours(contours);
    for(const c of normalized){
      subject.push(toCP(c));
    }
  }
  if(subject.length===0)return[];
  const clipper=new ClipperLib.Clipper();
  const simplified=ClipperLib.Clipper.SimplifyPolygons(subject,ClipperLib.PolyFillType.pftNonZero);
  clipper.AddPaths(simplified,ClipperLib.PolyType.ptSubject,true);
  const sol=new ClipperLib.Paths();
  clipper.Execute(ClipperLib.ClipType.ctUnion,sol,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  const cleaned=ClipperLib.Clipper.CleanPolygons(sol,0.15*CS);
  const minArea=20*CS*CS;
  return cleaned.filter(p=>Math.abs(ClipperLib.Clipper.Area(p))>minArea);
}

// ==================================================================
// GEOMETRY PIPELINE
// ==================================================================

function process(){
  if(!font||!S.name.trim())return null;
  if(!pawCache)pawCache=buildPawCache();

  const emSc=S.fontSize/font.unitsPerEm, chars=[...S.name.trim()];
  let nx=0;
  const layout=chars.map(ch=>{
    const adv=(font.charToGlyph(ch).advanceWidth||0)*emSc;
    const e={char:ch,nx};nx+=adv+S.letterSpacing;return e;
  });
  const lastL=layout[layout.length-1];
  const totalW=lastL.nx+(font.charToGlyph(lastL.char).advanceWidth||0)*emSc;
  const baseX=(W-totalW)/2, baseY=H/2+S.fontSize*0.2+S.nameOffsetY;

  // Flatten contours for each letter
  const letterContours=layout.map(({char,nx:lx})=>{
    const cmds=font.getPath(char,baseX+lx,baseY,S.fontSize).commands;
    return flatten(cmds,FLATTEN_TOL);
  });

  // CUT: union of paw (cached) + all letters
  const weldedSol=clipperUnionWithCachedPaw(pawCache.pawContoursCP,letterContours);
  const weldedCutPaths=weldedSol.map(p=>fromCP(p));
  const frontCutPathD=rawFillPath(weldedCutPaths);

  // BACK layer: optionally add ring, then outer offset
  let backCutArea=weldedSol.slice();
  let ringHoleArea=[];
  if(S.hoopEnabled){
    const h=hoopPos();
    const ringOuterArea=buildArea([[circleContour(h.cx,h.cy,HR)]]);
    ringHoleArea=buildArea([[circleContour(h.cx,h.cy,hIR)]]);
    backCutArea=diffAreas(unionAreas([...backCutArea,...ringOuterArea]),ringHoleArea);
  }
  backCutArea=offsetAreas(backCutArea,BACK_OFFSET);
  if(ringHoleArea.length)backCutArea=diffAreas(backCutArea,ringHoleArea);
  const backCutBounds=clipperBounds(backCutArea);
  const backCutPathD=rawFillPath(backCutArea.map(p=>fromCP(p)));

  // SCORE: layered letter seams, preserving overlap order
  const seamPathDs=[];
  for(let i=0;i<letterContours.length;i++){
    const frontArea=i<letterContours.length-1?buildArea(letterContours.slice(i+1)):[];
    appendVisibleLetterSeams(letterContours[i],frontArea,seamPathDs);
  }

  return{frontCutPathD,backCutPathD,backCutBounds,seamPathDs};
}

// ==================================================================
// Rendering
// ==================================================================

function renderFallback(){
  const tf=pawTf(),h=S.hoopEnabled?hoopPos():null,nm=S.name||'...';
  const p=[
    `<rect width="${W}" height="${H}" fill="${BG}"/>`,
    `<g transform="${gTf(tf)}"><path d="${PAW}" fill="${BACK_FILL}" stroke="${BACK_FILL}" stroke-width="14" stroke-linejoin="round" paint-order="stroke fill"/></g>`,
  ];
  if(h){
    p.push(`<path d="${ringPath(h)}" fill="${BACK_FILL}" fill-rule="evenodd"/>`);
    p.push(`<circle cx="${h.cx.toFixed(2)}" cy="${h.cy.toFixed(2)}" r="${hIR}" fill="${BG}"/>`);
  }
  p.push(
    `<g transform="${gTf(tf)}"><path d="${PAW}" fill="${BEIGE}"/></g>`,
    `<text x="${W/2}" y="${H/2+S.fontSize*.28+S.nameOffsetY}" font-family="Chewy,cursive" font-size="${S.fontSize}" text-anchor="middle" fill="${BEIGE}" stroke="${BROWN}" stroke-width="2.5" stroke-linejoin="round" paint-order="stroke fill">${nm}</text>`,
  );
  document.getElementById('boardSvg').innerHTML=p.join('');
}

function renderResult(){
  if(!ready||!font||!data){renderFallback();return;}
  const p=[
    `<rect width="${W}" height="${H}" fill="${BG}"/>`,
    `<path d="${data.backCutPathD}" fill="${BACK_FILL}" fill-rule="evenodd"/>`,
    `<path d="${data.frontCutPathD}" fill="${BEIGE}" fill-rule="evenodd"/>`,
    ...data.seamPathDs.map(d=>`<path d="${d}" fill="none" stroke="${BROWN}" stroke-width="${PSW}" stroke-linecap="round" stroke-linejoin="round"/>`),
  ];
  document.getElementById('boardSvg').innerHTML=p.join('\n');
}

// ==================================================================
// Overlay with delayed reveal (fixes the flash)
// ==================================================================

let ovTimer=null;
function showOv(msg,delay=0,isError=false){
  clearTimeout(ovTimer);ovTimer=null;
  const overlay=document.getElementById('procOverlay');
  const reveal=()=>{
    document.getElementById('procMsg').textContent=msg;
    overlay.classList.toggle('error',!!isError);
    overlay.classList.add('show');
  };
  if(delay<=0)reveal();
  else ovTimer=setTimeout(reveal,delay);
}
function hideOv(){
  clearTimeout(ovTimer);ovTimer=null;
  const overlay=document.getElementById('procOverlay');
  overlay.classList.remove('show');
  overlay.classList.remove('error');
}

// ==================================================================
// Scheduler — only flashes "Processing..." if work takes >300ms
// ==================================================================

function sched(d=40){
  clearTimeout(timer);
  if(!ready||!font){renderFallback();return;}
  timer=setTimeout(()=>{
    showOv('Processing...',300);         // only appears if process() is slow
    try{data=process();}catch(e){console.error(e);data=null;}
    hideOv();
    document.getElementById('dlBtn').disabled=!data;
    syncExportUi();
    renderResult();
  },d);
}

// ==================================================================
// Export SVG
// ==================================================================

function buildSVG(){
  if(!data)return null;
  const unit=S.exportUnit;
  const eH=mmToUnit(S.exportHeightMm,unit);
  const bounds=currentBackBounds();
  const scale=eH/Math.max(bounds.h,1e-6);
  const eW=bounds.w*scale;
  const totW=2*W+GAP,totWOut=totW*scale,totHOut=H*scale;
  const backCutEl=`    <path fill="none" stroke="#FF0000" stroke-width="1" stroke-linejoin="round" d="${data.backCutPathD}"/>`;
  const frontCutEl=`    <path fill="none" stroke="#FF0000" stroke-width="1" stroke-linejoin="round" d="${data.frontCutPathD}"/>`;

  const scoreEls=data.seamPathDs.map((d,i)=>
    `      <path id="seam-${i}" fill="none" stroke="#5C3317" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="${d}"/>`
  ).join('\n');

  return[
    `<?xml version="1.0" encoding="utf-8"?>`,
    `<!--`,
    `  Paw Name Generator — Laser Export`,
    `  Name: "${S.name}"  |  Chewy  |  ${S.fontSize}pt  |  Spacing: ${S.letterSpacing}px  |  Ring: ${S.hoopEnabled}`,
    `  Panel size: ${fmtMeasure(eW,unit)} x ${fmtMeasure(eH,unit)} ${unit}`,
    `  LEFT = back layer   RIGHT = front layer`,
    `  Cut = united paw + letters outline; back layer also merges hanging ring when enabled`,
    `  Score = layered letter seams (full letter outlines with overlap order)`,
    `  Cut = #FF0000  |  Score = #5C3317  |  stroke-width = 1`,
    `-->`,
    `<svg xmlns="http://www.w3.org/2000/svg"`,
    `     xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"`,
    `     viewBox="0 0 ${totW} ${H}" width="${fmtMeasure(totWOut,unit)}${unit}" height="${fmtMeasure(totHOut,unit)}${unit}">`,
    ``,
    `  <!-- ══ LEFT PANEL: BACK LAYER ══ -->`,
    `  <g id="back" inkscape:groupmode="layer" inkscape:label="Back - Cut">`,
    backCutEl,
    `  </g>`,
    ``,
    `  <!-- ══ RIGHT PANEL: FRONT LAYER ══ -->`,
    `  <g id="front" transform="translate(${W+GAP},0)">`,
    `    <g id="front-cut" inkscape:groupmode="layer" inkscape:label="Front - Cut">`,
    frontCutEl,
    `    </g>`,
    `    <g id="front-score" inkscape:groupmode="layer" inkscape:label="Front - Score">`,
    scoreEls,
    `    </g>`,
    `  </g>`,
    ``,
    `</svg>`,
  ].join('\n');
}
function download(){
  const s=buildSVG();if(!s){alert('Generate a name first.');return;}
  const a=Object.assign(document.createElement('a'),{
    href:URL.createObjectURL(new Blob([s],{type:'image/svg+xml;charset=utf-8'})),
    download:`paw-${(S.name||'name').replace(/[^a-z0-9]/gi,'-')}-laser.svg`,
  });
  document.body.appendChild(a);a.click();document.body.removeChild(a);URL.revokeObjectURL(a.href);
}

// ==================================================================
// Reset
// ==================================================================

function reset(){
  Object.assign(S,DEF);
  document.getElementById('ni').value=S.name;
  document.getElementById('szSlider').value=S.fontSize;
  document.getElementById('spSlider').value=S.letterSpacing;
  document.getElementById('oySlider').value=S.nameOffsetY;
  syncExportUi();
  document.querySelectorAll('#hoopSeg .sb').forEach(b=>b.classList.toggle('on',b.dataset.hoop==='false'));
  sched();
}

// ==================================================================
// Controls
// ==================================================================

document.getElementById('ni').value=S.name;
document.getElementById('ni').addEventListener('input',e=>{S.name=e.target.value;sched(120);});
document.getElementById('szSlider').addEventListener('input',e=>{S.fontSize=parseInt(e.target.value);sched(20);});
document.getElementById('spSlider').addEventListener('input',e=>{S.letterSpacing=parseInt(e.target.value);sched(20);});
document.getElementById('oySlider').addEventListener('input',e=>{S.nameOffsetY=parseInt(e.target.value);sched(20);});
document.getElementById('hoopSeg').addEventListener('click',e=>{
  const b=e.target.closest('.sb');if(!b)return;
  document.querySelectorAll('#hoopSeg .sb').forEach(x=>x.classList.remove('on'));
  b.classList.add('on');S.hoopEnabled=(b.dataset.hoop==='true');sched(20);
});
document.getElementById('ehInput').addEventListener('input',e=>{
  const raw=parseFloat(e.target.value);
  if(!Number.isFinite(raw))return;
  S.exportHeightMm=Math.max(EXPORT_MIN_MM,Math.min(EXPORT_MAX_MM,unitToMm(raw,S.exportUnit)));
  document.getElementById('exportDims').textContent=fmtExportDims();
});
document.getElementById('ehInput').addEventListener('change',e=>{
  const raw=parseFloat(e.target.value);
  if(Number.isFinite(raw))S.exportHeightMm=Math.max(EXPORT_MIN_MM,Math.min(EXPORT_MAX_MM,unitToMm(raw,S.exportUnit)));
  syncExportUi();
});
document.getElementById('unitSeg').addEventListener('click',e=>{
  const b=e.target.closest('.sb');if(!b)return;
  S.exportUnit=b.dataset.unit;
  syncExportUi();
});
document.getElementById('dlBtn').addEventListener('click',download);
document.getElementById('resetBtn').addEventListener('click',reset);
syncExportUi();

// ==================================================================
// Init
// ==================================================================

showOv('Loading libraries...');
renderFallback();
Promise.all([loadScript(LIB.opentype),loadScript(LIB.clipper)])
.then(()=>{
  if(typeof opentype==='undefined')throw new Error('opentype not defined');
  if(typeof ClipperLib==='undefined')throw new Error('ClipperLib not defined');
  ready=true;
  return document.fonts.ready;
})
.then(()=>loadFont())
.catch(err=>{showOv(`Failed: ${err.message} - reload`,0,true);console.error(err);});


// ==================================================================
// google analytics track
// ==================================================================

  document.addEventListener('DOMContentLoaded', function () {
    const nameInput = document.getElementById('ni');
    const downloadBtn = document.getElementById('dlBtn');

    if (!nameInput || !downloadBtn) return;

    function trackGAEvent(eventName, params = {}) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    }

    let pawNameTracked = false;

    // Track the first time someone enters a non-empty name
    nameInput.addEventListener('input', function () {
      const value = this.value.trim();

      if (!pawNameTracked && value.length > 0) {
        pawNameTracked = true;

        trackGAEvent('PawEnteredName', {
          generator_name: 'paw_sign',
          name_length: value.length
        });
      }
    });

    // Track every SVG download click
    downloadBtn.addEventListener('click', function () {
      const value = nameInput.value.trim();

      trackGAEvent('PawSVGDownload', {
        generator_name: 'paw_sign',
        has_name: value.length > 0,
        name_length: value.length
      });
    });
  });
